export default __webpack_public_path__ + "static/media/truck-02-thumbnail.a11b9cee.jpg";